import { Injectable } from '@angular/core';

// Interface for log entry
export interface LogEntry {
  timestamp: string;
  type: string;
  stepDescription: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppiumLogParserService {
  /**
   * Parses raw log data into a structured array of log entries
   * @param rawLogData - Raw log data as a string
   * @returns Array of parsed log entries
   */
  parseLogData(rawLogData: string): LogEntry[] {
    // Split the raw log data into lines
    const logLines = rawLogData.split('\n');
  
    // Parse each line into a log entry
    return logLines
      .map(line => this.parseSingleLogLine(line))
      .filter(entry => entry !== null) as LogEntry[];
  }
  
  /**
   * Parses a single log line into a LogEntry object
   * @param line - A single line from the log
   * @returns Parsed LogEntry or null if parsing fails
   */
  private parseSingleLogLine(line: string): LogEntry | null {
    // Regular expression to match two types of log formats
    const singleArrowPattern = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?) --> (.*)$/;
    const tripleArrowPattern = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?) --> (.*) --> (.*)$/;
  
    // Try triple arrow pattern first
    let match = line.match(tripleArrowPattern);
    if (match) {
      return {
        timestamp: match[1].trim(),
        type: match[2].trim(),
        stepDescription: match[3].trim()
      };
    }
  
    // If not triple arrow, try single arrow pattern
    match = line.match(singleArrowPattern);
    if (match) {
      return {
        timestamp: match[1].trim(),
        type: '',
        stepDescription: match[2].trim()
      };
    }
  
    // If no match found
    return null;
  }
  
  /**
   * Example usage method to demonstrate how to use the service
   * @param rawLogData - Raw log data as a string
   */
  exampleUsage(rawLogData: string): void {
    const parsedLogs = this.parseLogData(rawLogData);
  }
}